import React, { Component } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import FeeFormBody from "../FeeFormBody/FeeFormBody";

import CustomTableHead from "../../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import AddFeeForm from "../AddFeeForm/AddFeeForm";

class ViewFeeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Fee Head" },
        { name: "Price" },
        { name: "Paid ?" },
        { name: "Discount" },
        { name: "Remarks" },
        { name: "Actions" },
      ],
    };
  }

  render() {
    let filteredData = this.props.studentFeeDetails.fees.filter(
      (filter) => filter.month.indexOf(this.props.monthName) !== -1
    );
    return (
      <TableContainer>
        <Table>
          <CustomTableHead column={this.state.column} />
          <TableBody>
            <AddFeeForm
              initialFeeGroup={this.props.initialFeeGroup}
              monthName={this.props.monthName}
              studentFeeId={this.props.studentFeeId}
              getStudentFee={this.props.getStudentFee}
            />
            {filteredData.map((data, index) => (
              <FeeFormBody
                key={index}
                index={index}
                data={data}
                monthName={this.props.monthName}
                initialFeeGroup={this.props.initialFeeGroup}
                studentFeeId={this.props.studentFeeId}
                getStudentFee={this.props.getStudentFee}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default ViewFeeForm;
